import { memo } from 'react'

export const SamplePage = memo(() => {
  return <>Sample Page</>
})

SamplePage.displayName = 'SamplePage'
